/**
 * Google 로그인 시작 주소 — `AC-PF-02-01`
 *
 * **생성 클라이언트를 쓰지 않는 이유**: 이것은 데이터 요청이 아니라 브라우저의 화면 이동이다.
 * `fetch`로 부르면 302를 따라가 Google의 HTML을 받아버린다. 그래서 `<a href>`다 (E14 §8과
 * 같은 성격의 예외 — 생성 클라이언트가 표현할 수 없는 경로).
 *
 * 배포에서는 웹과 API가 다른 오리진이므로 API 오리진을 붙인다. 개발은 Vite 프록시가
 * `/v1`을 넘기므로 상대 경로가 맞다 (`main.tsx`의 `configureApiClient`와 같은 규칙).
 */
export function googleLoginHref(returnPath?: string): string {
  const apiBase = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');
  const start = `${apiBase}/v1/auth/google`;

  if (!returnPath) return start;
  return `${start}?return_path=${encodeURIComponent(returnPath)}`;
}
